
interface AliasConfig {
    aliasname: string;
    hostname: string;
    options: any;
}

export class Alias {

    public aliasname: string;
    public hostname: string;          // tslint:disable-line
    public options: any;       // tslint:disable-line


    constructor(config: AliasConfig) {
        Object.assign(this, config);
    }
}